import Persistable from "../../storage/persistable";

export default class Game extends Persistable {
    constructor(event = {}) {
        super();
        this.eventId = event.id;
    }
}
